<template>
  <div class="collapse">
    <label title="Collapse" @click="showContent=!showContent" class="collapse__label"><i class="material-icons icon">{{ showContent ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</i> {{this.name}}</label>
      <div class="collapse__content" v-if="showContent">
        <slot></slot>
      </div>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  props: {
    name: {
      type: String,
      default: ''
    },
  },
  data: () => ({
     showContent: null 
  }),
};
</script>